import React, { PropsWithChildren } from "react";
//#region redux
import { AppState } from "store";
import { useSelector } from "react-redux";
//#endregion
//#region types
import { sv } from "date-fns/locale";
import { LocaleEnums } from "models/enums";
//#endregion
//#region components
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
//#endregion

const DatePickerLocalization: React.FC<PropsWithChildren> = (props) => {
  const language = useSelector((store: AppState) => store.common.locale.language);

  const getLocale = () => {
    switch (language) {
      case LocaleEnums.LocaleType.sv:
        return sv;
      default:
        return undefined;
    }
  };
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={getLocale()}>
      {props.children}
    </LocalizationProvider>
  );
};

export default DatePickerLocalization;
